import React from 'react';

const AWS_Free_Tier = () => {
  return (
    <div>
      <h1>AWS_Free_Tier</h1>
      <p>This is the AWS_Free_Tier component.</p>
    </div>
  );
};

export default AWS_Free_Tier;
